"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleUpdateMeterRemark = exports.fetchMeterEntryRemark = exports.handleCreateTRMVRMeterEntryRemark = exports.fetchMeterRemarks = exports.fetchMeterEntryRemarks = exports.createRemarkResponse = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/trmvrmeterentries/remark");
const Actions = require("../../actions/trmvrmeterentries/remark");
const sok_types_1 = require("@caddigital/sok-types");
const remarkValidation_1 = require("../../utils/remarkValidation");
const { ImagesFolderListActions, ConfirmationImagesFolderListActions } = Actions;
const errorHandling_1 = require("../../utils/errorHandling");
exports.createRemarkResponse = t.interface({
    uuid: t.string
});
function fetchMeterEntryRemarks(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/trmvrmeter/${action.meterUuid}/entry/${action.entryUuid}/remarks`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        return t
            .array(sok_types_1.TRMVRMeterEntryRemark.iTRMVRMeterEntryRemark)
            .decode(xhr.response)
            .fold((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseValidationError)(error), action.meterUuid, action.entryUuid)), (cases) => (0, rxjs_1.of)(Actions.fetchSuccess(cases, action.meterUuid)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error), action.meterUuid))))));
}
exports.fetchMeterEntryRemarks = fetchMeterEntryRemarks;
function fetchMeterRemarks(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_ALL_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/trmvrmeter/${action.meterUuid}/remarks`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        return t
            .array(sok_types_1.TRMVRMeterEntryRemark.iTRMVRMeterEntryRemark)
            .decode(xhr.response)
            .fold((error) => (0, rxjs_1.of)(Actions.fetchAllFailed((0, errorHandling_1.parseValidationError)(error), action.meterUuid)), (cases) => (0, rxjs_1.of)(Actions.fetchAllSuccess(cases, action.meterUuid)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchAllFailed((0, errorHandling_1.parseAjaxErrorResponse)(error), action.meterUuid))))));
}
exports.fetchMeterRemarks = fetchMeterRemarks;
function handleCreateTRMVRMeterEntryRemark(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_REMARK_REQUEST), (0, operators_1.mergeMap)((request) => {
        const meterUuid = request.payload.meterUuid;
        const entryUuid = request.payload.entryUuid;
        const body = {
            target: request.payload.target,
            remark: request.payload.remark,
            responsible_company: request.payload.responsible_company,
            must_be_fixed_at: request.payload.must_be_fixed_at,
            additional_info: request.payload.additional_info,
            confirmation_comment: request.payload.confirmation_comment,
            meter_type: request.payload.meter_type
        };
        const validation = (0, remarkValidation_1.validateRemarkInformation)(body);
        return validation.fold((e) => (0, rxjs_1.of)(Actions.updateRemarkInfoValidation(e)).pipe((0, operators_1.delay)(500)), (x) => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: body,
            url: `${baseUrl}api/trmvrmeter/${meterUuid}/entry/${entryUuid}/remark`
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            return exports.createRemarkResponse
                .decode(xhr.response)
                .fold((error) => (0, rxjs_1.of)(Actions.createRemarkFailed((0, errorHandling_1.parseValidationError)(error))), (meterentry) => (0, rxjs_1.of)(Actions.createRemarkSuccess(meterentry)));
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.createRemarkFailed((0, errorHandling_1.parseAjaxErrorResponse)(e))))));
    }));
}
exports.handleCreateTRMVRMeterEntryRemark = handleCreateTRMVRMeterEntryRemark;
function fetchMeterEntryRemark(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REMARK_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/trmvrmeter/${action.meterUuid}/entry/${action.entryUuid}/remark/${action.remarkUuid}`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        return sok_types_1.TRMVRMeterEntryRemark.iTRMVRMeterEntryRemark
            .decode(xhr.response)
            .fold((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseValidationError)(error))), (remark) => (0, rxjs_1.of)(...[
            Actions.fetchRemarkSuccess(remark),
            ImagesFolderListActions.fetchRequest(remark.image_folder_id || 0, {
                sortBy: null,
                order: 'desc',
                limit: 350,
                offset: 0
            }),
            ConfirmationImagesFolderListActions.fetchRequest(remark.confirmation_image_folder_id || 0, {
                sortBy: null,
                order: 'desc',
                limit: 350,
                offset: 0
            })
        ]));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchMeterEntryRemark = fetchMeterEntryRemark;
function handleUpdateMeterRemark(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.UPDATE_REMARK_REQUEST), (0, operators_1.mergeMap)((request) => {
        const remarkUuid = request.payload.remarkUuid;
        const meterUuid = request.payload.meterUuid;
        const entryUuid = request.payload.entryUuid;
        const body = {
            target: request.payload.remark.target,
            responsible_company: request.payload.remark.responsible_company,
            must_be_fixed_at: request.payload.remark.must_be_fixed_at,
            additional_info: request.payload.remark.additional_info,
            confirmation_comment: request.payload.remark.confirmation_comment,
            meter_type: request.payload.remark.meter_type
        };
        const validation = (0, remarkValidation_1.validateRemarkInformation)(body);
        return validation.fold((e) => (0, rxjs_1.of)(Actions.updateRemarkInfoValidation(e)).pipe((0, operators_1.delay)(500)), (x) => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'PUT',
            body: request.payload.remark,
            url: `${baseUrl}api/trmvrmeter/${meterUuid}/entry/${entryUuid}/remark/${remarkUuid}`
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            return sok_types_1.TRMVRMeterEntryRemark.iTRMVRMeterEntryRemark
                .decode(xhr.response)
                .fold((error) => (0, rxjs_1.of)(Actions.updateRemarkFailed((0, errorHandling_1.parseValidationError)(error), remarkUuid)), (remark) => (0, rxjs_1.of)(Actions.updateRemarkSuccess(remark, remarkUuid)));
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.updateRemarkFailed((0, errorHandling_1.parseAjaxErrorResponse)(e), remarkUuid)))));
    }));
}
exports.handleUpdateMeterRemark = handleUpdateMeterRemark;
//# sourceMappingURL=remark.js.map